import { useContext, useEffect } from "react"

import { HelmetAttributes, HelmetContext } from "shared/types/HelmetContext"

export function useHelmet(helmetAttributes: HelmetAttributes) {
  const context = useContext(HelmetContext)
  useEffect(() => {
    context?.(helmetAttributes)
  }, [helmetAttributes])
}
